import type { ClinicAlert } from "@dentacore/shared-types";

import { api } from "./client";

/**
 * Unresolved notices from anywhere in the clinic.
 *
 * **Clinic-scoped, not branch-scoped**: the panel reads across every branch by
 * definition, so there is no active-branch header on it — the clinic comes from
 * the access token, and row-level security holds the line underneath.
 */
export function listClinicAlerts(signal?: AbortSignal): Promise<ClinicAlert[]> {
  return api<ClinicAlert[]>("/clinic-alerts", { signal });
}

/** Mark one done. Returns what remains, so the panel redraws without a second call. */
export function resolveClinicAlert(alertId: string): Promise<ClinicAlert[]> {
  return api<ClinicAlert[]>(`/clinic-alerts/${alertId}/resolve`, { method: "POST" });
}
